import React from 'react';
import PropTypes from 'prop-types';
import Auth from '../modules/Auth';
import LogoutModal from '../views/boards/components/modals/LogoutModal';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome';

class Navigation extends React.Component {

  static propTypes = {
    showRefreshing: PropTypes.func.isRequired,
    hideRefreshing: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showLogoutModal: false,
    };

    this.renderNavigationItems = this.renderNavigationItems.bind(this);
    this.renderAuthNavigation = this.renderAuthNavigation.bind(this);

    this.onShowLogoutModal = this.onShowLogoutModal.bind(this);
    this.onHideLogoutModal = this.onHideLogoutModal.bind(this);
  }

  static renderGuestNavigation() {
    let key = 0;

    const html = [
      <li className="nav-item" key={++key}>
        <Link to="/auth/login" className="nav-link">
          Login
        </Link>
      </li>,

      <li className="nav-item" key={++key}>
        <Link to="/auth/register" className="nav-link">
          Register
        </Link>
      </li>,
    ];

    return html.map(item => item);
  }

  onShowLogoutModal() {
    this.setState({
      showLogoutModal: true,
    });
  }

  onHideLogoutModal() {
    this.setState({
      showLogoutModal: false,
    });
  }

  renderAuthNavigation() {
    let key = 0;

    const html = [
      <li className="nav-item" key={++key}>
        <Link to="/boards/create" className="nav-link">
          Create Board
        </Link>
      </li>,

      <li className="nav-item" key={++key}>
        <Link to="/boards" className="nav-link">
          Board History
        </Link>
      </li>,

      <li className="nav-item" key={++key}>
        <Link to="/team-members" className="nav-link">
          Team Members
        </Link>
      </li>,

      <li className="nav-item" key={++key}>
        <Link to="/actions-tracker" className="nav-link">
          Actions Tracker
        </Link>
      </li>,

      <li className="nav-item icon" key={++key}>
        <a
          href="#!"
          className="nav-link"
          aria-haspopup="true"
          id="account-dropdown"
          aria-expanded="false"
          data-toggle="dropdown"
        >
          <FontAwesome icon="user-circle" className="d-none d-lg-inline" />

          <span className="d-inline d-lg-none">
            My Account
          </span>
        </a>

        <div className="dropdown-menu dropdown-menu-right mb-2 mb-lg-0" aria-labelledby="account-dropdown">
          <Link to="/auth/account" className="dropdown-item font-weight-medium">
            <FontAwesome icon="user-circle" className="mr-2" />

            {Auth.user().name}
          </Link>

          <Link to="/auth/integrations" className="dropdown-item">
            Integrations
          </Link>

          <button type="button" className="btn btn-link dropdown-item" onClick={this.onShowLogoutModal}>
            Logout
          </button>
        </div>
      </li>,
    ];

    return html.map(item => item);
  }

  renderNavigationItems() {
    const { showLogoutModal } = this.state;

    return (
      <React.Fragment>
        <ul className="navbar-nav ml-auto pt-2 pt-lg-0 pl-3 pl-lg-0">
          {Auth.user() === null && Navigation.renderGuestNavigation()}

          {Auth.user() !== null && this.renderAuthNavigation()}
        </ul>

        <LogoutModal show={showLogoutModal} hide={this.onHideLogoutModal} />
      </React.Fragment>
    );
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark">
        <Link to="/" className="navbar-brand">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Sprint Boards" width={170} />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar"
          aria-controls="navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className="collapse navbar-collapse" id="navbar">
          {this.renderNavigationItems()}
        </div>
      </nav>
    );
  }

}

export default withRouter(Navigation);
